module.exports = __webpack_public_path__ + "assets/img/user1.96a53910.png";